import { popupSlider } from "./logo-slider";
import 'leaflet'

export default function showOnMapPage() {
    // Show on map - fires upon click on "Show on map" on a single univ page
    $(document).ready( function () {
        if ($('#mapidMapPage').length > 0) {
            function initMap(locations) {
                var camp_lat = 40.705184;
                var camp_lng = -74.015971;
                var mymap = L.map("mapidMapPage", {
                    center: [camp_lat, camp_lng],
                    zoom: 13
                    // gestureHandling: true
                });

                L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}', {
                    attribution: '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
                    tileSize: 512,
                    maxZoom: 18,
                    zoomOffset: -1,
                    id: 'mapbox/streets-v11',
                    accessToken: 'pk.eyJ1IjoiYnViZW5jb2RlIiwiYSI6ImNqejJ0dTRuajAxNDEzaG8zbjc1cDhsZmYifQ.nsNcWadAYMyOBP0UJchN2w'
                }).addTo(mymap);

                var MyCustomMarker = L.Marker.extend({
                    bindPopup: function (htmlContent, options) {
                        if (options && options.showOnMouseOver) {
                            let xhr;
                            // call the super method
                            L.Marker.prototype.bindPopup.apply(this, [htmlContent, options]);

                            // bind the click event
                            this.on("click", function () {
                                this.openPopup()._initSlider();
                            });
                            let that = this;
                            // bind to mouse over
                            this.on("mouseover", function (e) {

                                // get the element that the mouse hovered onto
                                var target = e.originalEvent.fromElement || e.originalEvent.relatedTarget;
                                var parent = this._getParent(target, "leaflet-popup-wrapper-custom");

                                // check to see if the element is a popup, and if it is this marker's popup
                                if (parent == this._popup._container)
                                    return true;
                                $.ajax({
                                    url: window.glob_obj.ajaxurl,
                                    method: 'POST',
                                    dataType: 'json',
                                    data: {
                                        action: 'vendor_map_gallery_ajax_request',
                                        campus_id: options.campus_id,
                                    },
                                    beforeSend: function(jqXHR, settings){
                                        xhr = jqXHR;
                                    },
                                    success: function (response) {

                                        var images_list = '';
                                        if (response.images.length > 0) {
                                            for ( var i = 0; i < response.images.length; i++) {
                                                if (response.images[i][0]) {
                                                    images_list += '' +
                                                        '<a href="' + response.address + '" class="image">' +
                                                        '   <div><img src="' + response.images[i][0] + '" class="img-fluid slk-search" width="215"></div>' +
                                                        '</a>';
                                                }
                                            }
                                        } else {
                                            images_list = '' +
                                                '<a href="'+ response.address +'" class="image">' +
                                                '   <div><img src="'+ placeholder +'" class="img-fluid slk-search" width="215"></div>' +
                                                '</a>';
                                        }
                                        var htmlContent = '<div class="leaflet-popup-wrapper-custom">' +
                                            '<div class="slk-search-slider-wrapper popup-slider-wrapper">' +
                                            '   <div class="slk-search-slider popup-slider">' +
                                            images_list +
                                            '</div>' +
                                            '<div class="popup-body"><strong>' + options.item[2] + '</strong>'+ options.item[7] +'<div class="popup-campus-links"><a class="campus-link" href="' + options.item[4] + '">Read more...</a></div></div></div>';
                                        if(xhr.readyState == 4) {
                                            L.Marker.prototype.bindPopup.apply(that, [htmlContent, options]);

                                            that.openPopup()._initSlider();
                                        }


                                    },
                                    error: function(error){
                                        console.log(error);
                                        that.closePopup();
                                    }
                                });
                                // show the popup
                                this.openPopup()._initSlider();

                            }, this);

                            // and mouse out
                            this.on("mouseout", function (e) {

                                // get the element that the mouse hovered onto
                                var target = e.originalEvent.toElement || e.originalEvent.relatedTarget;

                                // check to see if the element is a popup
                                if (this._getParent(target, "leaflet-popup-wrapper-custom")) {

                                    L.DomEvent.on(this._popup._container, "mouseout", this._popupMouseOut, this);
                                    return true;

                                } else {
                                    xhr.abort();
                                    this.closePopup();
                                }

                            }, this);
                        }  // if
                    },
                    _initSlider: function () {
                        popupSlider();
                    },
                    _popupMouseOut: function (e) {

                        // detach the event
                        L.DomEvent.off(this._popup, "mouseout", this._popupMouseOut, this);

                        // get the element that the mouse hovered onto
                        var target = e.toElement || e.relatedTarget;

                        // check to see if the element is a popup
                        if (this._getParent(target, "leaflet-popup-wrapper-custom"))
                            return true;

                        // check to see if the marker was hovered back onto
                        if (target == this._icon)
                            return true;

                        // hide the popup
                        this.closePopup();

                    },
                    _getParent: function (element, className) {
                        var parent = element.parentNode;
                        while (parent != null) {
                            if (parent.className && L.DomUtil.hasClass(parent, className))
                                return parent;
                            parent = parent.parentNode;
                        }
                        return false;
                    }
                });

                var markers = new L.FeatureGroup();

                var placeholder = '/wp-content/themes/buy2themeforest-child/dist/images/placeholder-img_265x265.jpg';

                if (locations && locations.length > 0) {
                    locations.forEach(function (item) {
                        var marker;
                        var latlng = [item[0], item[1]];

                        marker = new MyCustomMarker(latlng, {riseOnHover: true});

                        // var marker = L.marker([ camp_lat, camp_lng ], {icon: campusIcon}); // .addTo(mymap)
                        marker.bindPopup('<div class="leaflet-popup-wrapper-custom">' +
                            '<div class="slk-search-slider-wrapper popup-slider-wrapper">' +
                            '   <div class="slk-search-slider popup-slider">' +
                                '<div class="popup-slider-loader">' +
                                    '<div id="loader" class="overlay overlay_light"><div class="overlay__inner"><div class="overlay__content"><span class="spinner map_overlay_spinner"></span></div></div></div>' +
                                '</div>'+
                            '   </div>' +
                            '</div>' +
                            '<div class="all popup-body"><strong>' + item[2] + '</strong>' + item[7] + '<div class="popup-campus-links"><a class="campus-link" href="' + item[4] + '">Read more...</a></div></div></div>', {
                            showOnMouseOver: true,
                            campus_id : item[5],
                            item: item
                        })
                        markers.addLayer(marker);

                    });
                }
                mymap.addLayer(markers);

            }

            if ($('#mapidMapPage').length > 0) {
                var locations = $('#leafletHelper').data('siblings');

                initMap(locations);
            }
        }
    });
}
